<!-- From Uiverse.io by SelfMadeSystem -->
<div class="flex items-start justify-start gap-2">
  <div class="checkbox-container">
    <label class="checkbox-label">
      <input type="checkbox" [checked]="checked()" (change)="checked.set($any($event.target).checked)" />
      <div class="checkbox-wrapper">
        <div class="checkbox-bg"></div>
        <svg class="checkbox-icon" viewBox="0 0 24 24" fill="none">
          <path
            class="check-path"
            d="M4 12L10 18L20 6"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>
    </label>
  </div>
  <div class="flex-1">
    <ng-content></ng-content>
  </div>
</div>
